import apiClient from "../clients/apiClient";
import { safeRequest } from "../safeRequest";

export const RankingsService = {
  async getAll(clubId) {
    if (!clubId) {
      return { status: 400, data: null, message: "clubId ausente" };
    }
    return safeRequest(
      apiClient.get(`/clubs/${clubId}/rankings`).then((response) => response.data),
    );
  },
  async create(clubId, payload) {
    if (!clubId) {
      return { status: 400, data: null, message: "clubId ausente" };
    }
    return safeRequest(
      apiClient
        .post(`/clubs/${clubId}/rankings`, payload)
        .then((response) => response.data),
    );
  },
  async update(clubId, rankingId, payload) {
    if (!clubId) {
      return { status: 400, data: null, message: "clubId ausente" };
    }
    return safeRequest(
      apiClient
        .patch(`/clubs/${clubId}/rankings/${rankingId}`, payload)
        .then((response) => response.data),
    );
  },
  async getRounds(clubId, rankingId) {
    if (!clubId) {
      return { status: 400, data: null, message: "clubId ausente" };
    }
    return safeRequest(
      apiClient
        .get(`/clubs/${clubId}/rankings/${rankingId}/rounds`)
        .then((response) => response.data),
    );
  },
  async createRound(clubId, rankingId, body = {}) {
    if (!clubId) {
      return { status: 400, data: null, message: "clubId ausente" };
    }
    return safeRequest(
      apiClient
        .post(`/clubs/${clubId}/rankings/${rankingId}/rounds`, body)
        .then((response) => response.data),
    );
  },
  async addPlayers(clubId, rankingId, payload) {
    if (!clubId) {
      return { status: 400, data: null, message: "clubId ausente" };
    }
    const normalizedPayload =
      payload?.playerIds && payload?.categoryId
        ? {
            players: payload.playerIds.map((playerId) => ({
              playerId,
              categoryId: payload.categoryId,
            })),
          }
        : payload;
    return safeRequest(
      apiClient
        .post(`/clubs/${clubId}/rankings/${rankingId}/players`, normalizedPayload)
        .then((response) => response.data),
    );
  },
  async getStandings({ clubId, rankingId, categoryId }) {
    if (!clubId) {
      return { status: 400, data: null, message: "clubId ausente" };
    }
    return safeRequest(
      apiClient
        .get(`/clubs/${clubId}/rankings/${rankingId}/standings`, {
          params: { categoryId },
        })
        .then((response) => response.data),
    );
  },
  async removePlayer(clubId, rankingId, playerId) {
    if (!clubId) {
      return { status: 400, data: null, message: "clubId ausente" };
    }
    return safeRequest(
      apiClient
        .delete(`/clubs/${clubId}/rankings/${rankingId}/players/${playerId}`)
        .then((response) => response.data),
    );
  },
};
